import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

export default function useJobs() {
  const result = useQuery(gql`
    {
      careerdivisions {
        id
        name
        careerjobs {
          id
          title
          Description
          careerlocation {
            id
            name
          }
          careerlevel {
            id
            name
          }
        }
      }
    }
  `);
  return result;
}
